import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import locale from "locale";

import {
    requestCreateReminder,
    requestRemoveReminder,
    requestSendReminder,
    getTemplates,
    requestGetReminders,
} from "../../../../api/cp";
import RemindersBreadcrumbs from "./components/RemindersBreadcrumbs";
import RemindersTable from "./components/RemindersTable";
import {Panel, Glyphicon} from 'react-bootstrap';
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelBody from "react-bootstrap/lib/PanelBody";
import EmailTemplateLayoutModel from "./components/EmailTemplateLayoutModel";
import { TEMPLATE_TYPES } from "../LettersConstructor/models";

const Reminders = ({ event }) => {
    const history = useHistory();

    const [remindersList, setRemindersList] = React.useState([]);
    const [templates, setTemplates] = React.useState([]);
    const [reminderType, setReminderType] = React.useState("");

    React.useEffect(getReminders, []);

    async function getReminders() {
        try {
            const reminders = await requestGetReminders(event.eventKey);
            setRemindersList(reminders);
        } catch (error) {
            alert(
                error?.error?.message ??
                    error?.message ??
                    "Error requestGetReminder"
            );
        }
    }

    async function createReminder(emailMessageTemplate, subjects) {
        const data = {
            name: null,
            subjectRu: subjects.subjectRu,
            subjectEn: subjects.subjectEn,
            sendPeriodic: null,
            sendAt: null,
            senderEmail: null,
            senderName: null,
            recipientsSource: reminderType,
        };

        try {
            const reminder = await requestCreateReminder(
                emailMessageTemplate,
                data
            );
            const reminders = remindersList?.slice() ?? [];
            reminders.push(reminder);

            setRemindersList(reminders);

            editReminder(reminder);
        } catch (error) {
            alert(
                error?.error?.message ??
                    error?.message ??
                    "Error createReminder"
            );
        }
    }

    function editReminder(reminder) {
        history.replace(
            `/event/${event.eventPassword}/edit-reminders/${reminder.emailMessageTemplate.id}/${reminder.id}`
        );
    }

    async function submitReminder(reminderId) {
        if (!confirm(`${locale("reminders.confirmSendReminder")}?`)) {
            return;
        }

        try {
            await requestSendReminder(reminderId);
            alert(locale("reminders.successSubmitReminder"));
        } catch (error) {
            alert(
                error?.error?.message ??
                    error?.message ??
                    "Error submitReminder"
            );
        }
    }

    async function removeReminder(reminder) {
        try {
            await requestRemoveReminder(reminder.id);
            const reminders =
                remindersList?.filter(({ id }) => id !== reminder.id) ?? [];
            setRemindersList(reminders);
        } catch (error) {
            alert(
                error?.error?.message ??
                    error?.message ??
                    "Error removeReminder"
            );
        }
    }

    async function fetchEmailTemplates() {
        try {
            const response = await getTemplates(event.eventKey);
            const filtered = response.filter(({ type }) =>
                TEMPLATE_TYPES.includes(type)
            );

            if (filtered && filtered.length) {
                setTemplates(filtered);

                return filtered;
            } else {
                alert(locale("reminders.noCustomTemplatesFound"));
            }
        } catch (error) {
            alert(
                error?.error?.message ??
                    error?.message ??
                    "Error fetchEmailTemplates"
            );
        }
    }

    function isEmailTemplateModalVisible() {
        return Boolean(reminderType) && Boolean(templates?.length);
    }

    async function onCreateReminder(type) {
        const filtredTemplates = await fetchEmailTemplates();
        filtredTemplates && filtredTemplates.length && setReminderType(type);
    }

    return (
        <section className="event-reminders">
            <RemindersBreadcrumbs
                event={event}
                isCreateAvailable={Boolean(templates?.length)}
                onCreateReminder={onCreateReminder}
            />
            <Panel>
                <PanelHeading><Glyphicon glyph={"question-sign"} /> <strong>Как работает отправка писем?</strong></PanelHeading>
                <PanelBody>
                    <p>Система рассылок может отправлять только 2 письма в секунду, поэтому, когда планируете рассылку, учтите эту скорость и определите, когда необходимо начать процесс, чтобы адресаты получили письмо вовремя.</p>
                    <p>Для разных видов рассылок (системные и кастомные) создаются отдельные очереди. Таким образом, письма о регистрации отправляются отдельно от кастомных писем, которые идут из своей собственной очереди.</p>
                </PanelBody>
            </Panel>
            <RemindersTable
                event={event}
                reminders={remindersList}
                onEdit={editReminder}
                onSubmit={submitReminder}
                onDelete={removeReminder}
            />
            <EmailTemplateLayoutModel
                event={event}
                isModalVisible={isEmailTemplateModalVisible()}
                templates={templates}
                createReminder={createReminder}
                onClose={() => setReminderType("")}
            />
        </section>
    );
};

const mapStateToProps = (store) => ({
    event: store.currentEvent,
});

export default connect(mapStateToProps)(Reminders);
